// extracted by mini-css-extract-plugin
module.exports = {"HighlightedValue":"HighlightedValue","combineHandicapBox":"combineHandicapBox","score":"score","estimatedHandicapDescription":"estimatedHandicapDescription"};